var _defs, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 820,
    height: 250,
    viewBox: "0 15 820 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f46e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cardShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 14,
    floodColor: "#1e1b4b",
    floodOpacity: 0.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 150,
    height: 164,
    rx: 18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 48,
    width: 150,
    height: 164,
    rx: 18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 48,
    width: 150,
    height: 164,
    rx: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 150,
    height: 164,
    rx: 18,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 48,
    width: 150,
    height: 164,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100,110 100,150 135,130",
    fill: "#4f46e5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 190,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#c7d2fe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 48,
    width: 150,
    height: 164,
    rx: 18,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 48,
    width: 150,
    height: 164,
    fill: "#fef3c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 100,
    r: 24,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335,160 380,125 415,150 460,115 485,135 485,212 335,212",
    fill: "#86efac"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 190,
    width: 90,
    height: 10,
    rx: 5,
    fill: "#fde68a"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 48,
    width: 150,
    height: 164,
    rx: 18,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 48,
    width: 150,
    height: 164,
    fill: "#eef2ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 108,
    r: 28,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 97,
    r: 12,
    fill: "#818cf8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 140 Q705 118 732 140 L732 164 L678 164 Z",
    fill: "#818cf8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 190,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#e5e7eb"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 48,
    r: 19,
    fill: "url(#heroGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 39v14m0 0l-6-6m6 6l6-6",
    stroke: "#fff",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 48,
    r: 19,
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 39v14m0 0l-6-6m6 6l6-6",
    stroke: "#fff",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 48,
    r: 19,
    fill: "url(#heroGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 39v14m0 0l-6-6m6 6l6-6",
    stroke: "#fff",
    strokeWidth: 2.6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.1821ffa8c9cc7bfcbced4fb38b83fb8a.svg";
export { ForwardRef as ReactComponent };